import { CloseIcon } from '@blueprinthq/joy'
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay
} from '@chakra-ui/react'
import { WistiaPlayer } from '@components'
import React from 'react'

export const VideoModal = ({
  url,
  handleVideoClose,
  isOpenPreviewVideo,
  onClosePreviewVideo,
  wistiaId,
  footerContent
}: {
  url?: string
  handleVideoClose?: () => void
  isOpenPreviewVideo: boolean
  onClosePreviewVideo: () => void
  wistiaId?: string
  footerContent?: React.ReactNode
}) => {
  return (
    <Modal
      isOpen={isOpenPreviewVideo}
      onClose={onClosePreviewVideo}
      size="full"
    >
      <ModalOverlay />
      <ModalContent width="100vw" minHeight="100vh" margin="0">
        <ModalBody
          padding="0"
          width="100%"
          height="100%"
          position="relative"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box display="flex" justifyContent="flex-end" pr="10px" pt="10px">
            <Button
              variant="ghost"
              color="primary"
              rightIcon={<CloseIcon fill="primary" />}
              onClick={
                handleVideoClose
                  ? () => handleVideoClose()
                  : () => onClosePreviewVideo()
              }
              _focus={{
                boxShadow: 'none'
              }}
              bg={{
                base: 'transparent',
                md: 'rgba(255, 255, 255, 0.5)'
              }}
              data-click-text="Close"
            >
              Close
            </Button>
          </Box>
          <Box
            flex="1"
            width="100%"
            w={{
              base: '100%',
              md: '75%'
            }}
            margin="0 auto"
            padding={{
              base: '8px',
              md: '16px'
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {wistiaId ? (
              <WistiaPlayer wistiaId={wistiaId} />
            ) : (
              <Box
                position="relative"
                width="100%"
                paddingTop="56.25%"
                borderRadius="6px"
                overflow="hidden"
              >
                <Box position="absolute" top="0" left="0" right="0" bottom="0">
                  <video
                    preload="auto"
                    controls
                    disablePictureInPicture
                    controlsList="noremoteplayback nodownload"
                    autoPlay
                    playsInline
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                      borderRadius: '6px'
                    }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </Box>
              </Box>
            )}
          </Box>
          {footerContent}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
